import { styled } from '@glitz/react';
import * as React from 'react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import Link from './Link';
import { edgeMarginsDecorator, maxContentNormalWidthDecorator } from './page-layout';
import { NnTestIdProps } from 'webapp/shared/test-ids';

type PropType = Excite.Core.BreadcrumbsApiModel & { isProductPage?: boolean };

export const BreadCrumbs = styled((props: PropType) => {
  return (
    <BreadcrumbsWrapper>
      <Items>
        {(props?.segments ?? []).map((item, index) => (
          <React.Fragment key={item.url}>
            {index === 0 ? (
              <FirstBreadCrumbsItem css={index + 1 === props.segments.length && lastItemDecorator}>
                {index < props.segments.length - 1 || props.isProductPage ? (
                  <BreadcrumbLink to={item.url} {...NnTestIdProps.BreadCrumbLink}>
                    {item.name}
                  </BreadcrumbLink>
                ) : (
                  item.name
                )}
              </FirstBreadCrumbsItem>
            ) : (
              <BreadCrumbsItem css={index + 1 === props.segments.length && lastItemDecorator}>
                {index < props.segments.length - 1 || props.isProductPage ? (
                  <BreadcrumbLink to={item.url} {...NnTestIdProps.BreadCrumbLink}>
                    {item.name}
                  </BreadcrumbLink>
                ) : (
                  item.name
                )}
              </BreadCrumbsItem>
            )}
            {index < props.segments.length - 1 && '/'}
          </React.Fragment>
        ))}
      </Items>
    </BreadcrumbsWrapper>
  );
});

const BreadcrumbsWrapper = styled.div(
  maxContentNormalWidthDecorator,
  edgeMarginsDecorator,
  createMinLargeViewportDecorator({
    fontSize: t => t.breadcrumbs.fontSizeLargeViewport,
    margin: { y: t => t.spacing.m },
  }),
  {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: t => t.breadcrumbs.fontSizeBase,
    margin: { y: t => t.spacing.xs },
  },
);

const BreadcrumbLink = styled(Link, {
  textDecoration: 'none',
});

const Items = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'wrap',
  fontWeight: t => t.breadcrumbs.segmentFontWeight,
});

const lastItemDecorator = styled({ fontWeight: 'normal', color: t => t.breadcrumbs.lastSegmentColor });

const BreadCrumbsItem = styled.span({
  color: t => t.breadcrumbs.color,
  margin: { x: 4 },
});

const FirstBreadCrumbsItem = styled(BreadCrumbsItem, {
  marginLeft: 0,
});
